import { useCallback, useEffect, useRef, useState } from 'react'

// Mirrors the API's resend cooldown so the button stays disabled for as long as the API would refuse.
export const RESEND_COOLDOWN_MS = 30 * 1000

/** Tracks which customer ids are in the authorization email cooldown. */
export function useResendCooldown() {
  const [coolingDownIds, setCoolingDownIds] = useState([])
  const timersRef = useRef({})

  useEffect(() => {
    const timers = timersRef.current
    return () => Object.values(timers).forEach(clearTimeout)
  }, [])

  const startCooldown = useCallback((id) => {
    setCoolingDownIds((prev) => (prev.includes(id) ? prev : [...prev, id]))
    clearTimeout(timersRef.current[id])
    timersRef.current[id] = setTimeout(() => {
      setCoolingDownIds((prev) => prev.filter((coolingDownId) => coolingDownId !== id))
      delete timersRef.current[id]
    }, RESEND_COOLDOWN_MS)
  }, [])

  const isCoolingDown = useCallback((id) => coolingDownIds.includes(id), [coolingDownIds])

  return { startCooldown, isCoolingDown }
}
